"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserName = exports.UserCircle = exports.DetailsWrapper = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Variables_1 = require("../Variables");
var margin_1 = __importDefault(require("../Utils/margin"));
var padding_1 = __importDefault(require("../Utils/padding"));
exports.DetailsWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  padding: 0 ", ";\n  > * {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"], ["\n  ", "\n  ", "\n  padding: 0 ", ";\n  > * {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"])), margin_1.default, padding_1.default, Variables_1.padding.MD, Variables_1.margin.MD, Variables_1.margin.MD);
exports.UserCircle = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  width: 40px;\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 50%;\n  color: ", ";\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  width: 40px;\n"])), Variables_1.color.DIGITAL_DARK_GREY, Variables_1.color.BRAND_WHITE);
exports.UserName = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var UserDetails = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, props = __rest(_a, ["firstName", "lastName"]);
    if (!firstName && !lastName)
        return null;
    return (React.createElement(exports.DetailsWrapper, __assign({}, props),
        React.createElement(exports.UserCircle, null, firstName === null || firstName === void 0 ? void 0 :
            firstName.charAt(0), lastName === null || lastName === void 0 ? void 0 :
            lastName.charAt(0)),
        React.createElement(exports.UserName, null, "".concat(firstName, " ").concat(lastName))));
};
exports.default = UserDetails;
var templateObject_1, templateObject_2, templateObject_3;
